export const PAGE_ORGANIZATION_CHART = "/organization/organizational-chart";
export const PAGE_ORGANIZATION_STAFF = "/organization/staff-departments";
export const PAGE_NEW_ORGANIZATION_STAFF = "/organization/staff-departments/new";
export const PAGE_EDIT_ORGANIZATION_STAFF = "/organization/staff-departments/edit";
export const PAGE_ORGANIZATION_SETTINGS = "/org-settings";
